import { useEffect, useState } from 'react';

import { api } from './api';
import { deliveryStatusOptions } from './delivery-status';
import { CloseIcon, DeliveryIcon } from './icons';

export interface DeliveryInvoice {
  id: string;
  sku: string;
  deliveryStatus: number;
  updatedAt: string;
}

export function DeliveryStatusModal({ invoice, onClose, onChanged }: {
  invoice: DeliveryInvoice;
  onClose: () => void;
  onChanged: (message: string) => void;
}) {
  const [status, setStatus] = useState(invoice.deliveryStatus);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !saving) onClose();
    };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [onClose, saving]);

  async function save() {
    setSaving(true);
    setError('');
    try {
      const result = await api<{ invoice: { message: string } }>(`/api/invoices/outbound/${invoice.id}/delivery`, {
        method: 'PUT',
        body: JSON.stringify({ status, updatedAt: invoice.updatedAt })
      });
      onChanged(result.invoice.message);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Không thể cập nhật trạng thái giao hàng.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="drawer-backdrop" role="presentation">
      <section className="confirm-modal delivery-modal" role="dialog" aria-modal="true" aria-labelledby="delivery-title">
        <header className="drawer-header"><h2 id="delivery-title">Trạng thái giao hàng</h2><button type="button" className="icon-button" onClick={onClose} disabled={saving} aria-label="Đóng"><CloseIcon /></button></header>
        <div className="confirm-content">
          <div className="delivery-context"><span>Hóa đơn</span><strong>{invoice.sku}</strong></div>
          <div className="field"><label htmlFor="delivery-status">Trạng thái</label><select id="delivery-status" value={status} onChange={(event) => { setStatus(Number(event.target.value)); setError(''); }}>{deliveryStatusOptions(status).map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}</select></div>
          {error ? <div className="detail-error" role="alert">{error}</div> : null}
        </div>
        <footer className="drawer-footer"><button type="button" className="secondary-action" onClick={onClose} disabled={saving}>Hủy</button><button type="button" className="primary-action" onClick={() => void save()} disabled={saving || status === invoice.deliveryStatus}>{saving ? <span className="button-spinner" /> : <DeliveryIcon />} {saving ? 'Đang lưu…' : 'Cập nhật'}</button></footer>
      </section>
    </div>
  );
}
